import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import {forkJoin} from 'rxjs';
import {GarantiasIdoneas} from '../../../_models/garantias-idoneas';
import {ListaService} from '../../../_services/lista.service';
import {NavService} from '../../../_services/_nav.service';
import {AutenticacionService} from '../../../_services/autenticacion.service';
import {GarantiasIdoneasMunicipio} from '../../../_models/garantias-idoneas-municipio';
import {DivisionPolitica} from '../../../_models/division-politica';
import {GarantiaIdoneasMunicipioService} from '../../../_services/garantia-idoneas-municipio.service';
import {DivisionPoliticaService} from '../../../_services/division-politica.service';
import {GarantiasIdoneasProducto} from '../../../_models/garantias-idoneas-producto';
import {Producto} from '../../../_models/producto';
import {GarantiaIdoneasActividadesService} from '../../../_services/garantia-idoneas-actividades.service';
import {ProductoService} from '../../../_services/producto.service';
import {GarantiaIdoneasProductoService} from '../../../_services/garantia-idoneas-producto.service';
import {SegmentoProducto} from '../../../_models/segmento-producto';

@Component( {
  selector: 'app-garantia-idoneas-producto',
  templateUrl: 'garantia-idoneas-producto.component.html'
} )

export class GarantiaIdoneasProductoComponent implements OnInit {

  formulario: FormGroup;
  /** items */
  @Input() garantia: GarantiasIdoneas;
  producto: GarantiasIdoneasProducto;

  /** Listas */
  listGarantiasIdoneasProducto: GarantiasIdoneasProducto[] = [];
  productos: SelectItem[];
  allProductos: Producto[];

  columnas: any[] = [];
  carInformacionInicial = true;
  submitted = false;
  guardando = false;
  carTabla = true;
  indicadorPlan = false;
  @ViewChild('dt') tabla: Table;

  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService,
    private garantiasIdoneasProducto: GarantiaIdoneasProductoService,
    private confirmacionServicio: ConfirmationService,
    private productosService: ProductoService,
  ) {
  }

  ngOnInit() {

    if ( this.garantia && (this.garantia.idGarantiaIdonea !== '' && this.garantia.idGarantiaIdonea !== null && this.garantia.idGarantiaIdonea !== undefined) ) {
      /** Se carga garantias Servicios */
      forkJoin(
        this.garantiasIdoneasProducto.listadoPorProducto( this.garantia.idGarantiaIdonea ),
        this.productosService.listado()
      ).subscribe( ( [ garantiaProducto, productos ] ) => {
        this.listGarantiasIdoneasProducto = garantiaProducto;
        productos = productos.sort(function (a, b) {
          return a.orden - b.orden;
        });
        this.allProductos = productos;
        this.cargarInformacionInicial();
      } );
    }

  }

  get getGarantiasIdoneasDestino() {
    return this.listGarantiasIdoneasProducto.filter( s => s.indicadorHabilitado );
    this.carTabla = false;
  }


  cargarInformacionInicial() {

    this.carTabla = false;
    this.columnas = [
      { field: 'codigoProducto', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_PRODUCTO_CODIGO' ), sort: true },
      { field: 'producto', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_PRODUCTO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.formulario = this.fb.group( {
      idGarantiaIdonea: [ this.producto ? this.producto.idGarantiaIdonea : null ],
      idProducto: [ [], [ Validators.required ] ],
      indicadorHabilitado: [ true ]
    } );

    this.indicadorPlan = false;
    this.carInformacionInicial = false;
    this.carDropdown();
  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const forData = this.formulario.value;

      const tempGarantiasProducto: GarantiasIdoneasProducto[] = [];
      forData.idProducto.forEach(producto => {
        let temp = {} as GarantiasIdoneasProducto;
        temp.idGarantiaIdonea = this.garantia.idGarantiaIdonea;
        temp.idProducto = producto;
        temp.indicadorHabilitado = true;
        const a = this.listGarantiasIdoneasProducto.find( sp => sp.idProducto === temp.idProducto );
        if ( a ) {
          temp.idGarantiaIdoneaProducto = a.idGarantiaIdoneaProducto;
        }
        tempGarantiasProducto.push(temp);
      });

      this.garantiasIdoneasProducto.bulk( tempGarantiasProducto ).subscribe( res => {
        const tempSegmentoP: GarantiasIdoneasProducto[] = this.listGarantiasIdoneasProducto;
        this.listGarantiasIdoneasProducto = [];
        res.map(re => {
          re.codigoProducto = this.allProductos.find( p => p.idProducto === re.idProducto ).codigo;
          re.producto = this.allProductos.find( p => p.idProducto === re.idProducto ).nombre;
          tempSegmentoP.map( t => {
            if ( t.idGarantiaIdoneaProducto === re.idGarantiaIdoneaProducto ) {
              t.indicadorHabilitado = true;
            }
          } );
          if(!tempSegmentoP.find(di => di.idGarantiaIdoneaProducto ===  re.idGarantiaIdoneaProducto)){
            tempSegmentoP.push(re);
          }
        });
        this.listGarantiasIdoneasProducto = tempSegmentoP;
        this.carDropdown();
        this.formulario.reset();
        this.submitted = false;
        this.guardando = false;
      } );

    } else {
      return;
    }
  }

  disable( row: GarantiasIdoneasProducto ): void {
    this.confirmacionServicio.confirm( {
      message: '¿Está seguro que desea inactivar este registro?',
      header: 'Garantías idóneas Producto',
      icon: 'fa fa-question-circle',
      key: 'garantia-idoneas-producto',
      accept: () => {
        row.indicadorHabilitado = false;
        this.garantiasIdoneasProducto.actualizar( row ).subscribe( res => {
          const temp: GarantiasIdoneasProducto[] = this.listGarantiasIdoneasProducto;
          this.listGarantiasIdoneasProducto = [];
          temp.map( t => {
            if ( t.idGarantiaIdoneaProducto === row.idGarantiaIdoneaProducto ) {
              t.indicadorHabilitado = false;
            }
          } );
          this.listGarantiasIdoneasProducto = temp;
          this.carDropdown();
        } );
      }
    } );
  }


  carDropdown(): void {
    this.productos = [];
    this.allProductos.map( p => {
      if ( p.indicadorHabilitado && !this.listGarantiasIdoneasProducto.find( sp =>
        sp.indicadorHabilitado && sp.idProducto === p.idProducto ) ) {
        this.productos.push( { label: p.nombre, value: p.idProducto } );
      }
    } );
  }



  }
